
import { Component, Mixins } from "vue-property-decorator";
import WizardMixin from "../wizard.mixin";
import Header from "../header.vue";
import { WizardStep } from "@/types/enums.type";

@Component({
  components: {
    Header
  }
})
export default class WizardCompleteComponent extends Mixins(WizardMixin) {
  WizardStep = WizardStep;
}
